// Central place for HostelNow support/customer-care contact.
// Update once → propagates everywhere (dashboards, booking success, footer).
export const SUPPORT_PHONE = "+918080977658";
export const SUPPORT_PHONE_DISPLAY = "+91 80809 77658";
export const SUPPORT_WHATSAPP = "918080977658"; // for wa.me links (no +)
export const SUPPORT_EMAIL = "nowproductions15@gmail.com";

export function buildSupportWhatsAppLink(context = "") {
  const base = context
    ? `Hi HostelNow support! I need help with: ${context}`
    : "Hi HostelNow support! I need some help with my booking.";
  return `https://wa.me/${SUPPORT_WHATSAPP}?text=${encodeURIComponent(base)}`;
}
